<template>
    <div class="lead-generator-wrapper">
        <h2 class="h2-header">Lead an Webhook senden</h2>
        <v-text-field :loading="loading" density="compact" variant="outlined" rounded="lg" single-line hide-details v-model="webhookData"
            label="Webhook URL"></v-text-field>
        <div class="lead-generator-inside-wrapper">
            <v-textarea :rows="large ? 16 : 5" :loading="loading" variant="outlined" rounded="lg" hide-details v-model="jsonData"
                label="JSON"></v-textarea>
            <v-btn :loading="loading" class="gradient-color-primary json-btn" rounded="lg" @click="useGenerator()">JSON senden</v-btn>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        large: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            webhookData: '',
            jsonData: '',
        }
    },
    computed: {
        ...mapState('leadGenerator', ['loading'])
    },
    methods: {
        ...mapActions('leadGenerator', ['sendJSONToWebhook']),
        async useGenerator() {
            if (this.webhookData && this.jsonData) {
                let parsedJsonData;
                try {
                    parsedJsonData = JSON.parse(this.jsonData);
                    console.log(parsedJsonData);
                } catch (e) {
                    alert('Invalid JSON data');
                    return;
                }
                await this.$store.dispatch('leadGenerator/sendJSONToWebhook', { webhookData: this.webhookData, jsonData: this.jsonData })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.lead-generator-wrapper {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 12px;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    background-color: white;
}

.lead-generator-inside-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 16px;
}

.number-text-field {
    max-width: 100px;
}

.json-btn {
    margin-top:auto;
}
</style>